module.exports = __webpack_public_path__ + "static/Fabriga-Medium-dd1b4e9cc554cf70da388f26ea39c022.woff2";